import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import cards from '@/assets/icons/cards.png';
import coin from '@/assets/icons/coin-icn-sm.svg';
import key from '@/assets/icons/key-icn-sm.svg';
import star from '@/assets/icons/star-icn-sm.svg';
import { User } from '@/types/models/profile';
import { formatNumberShort, formatNumberShortExt } from '@/utils/format';

import { Badge } from '../Badge';
import styles from './Currency.module.scss';

type CurrencyProps = {
  showBadges?: boolean;
  showCoins?: boolean;
  showXp?: boolean;
  showKeys?: boolean;
  user: User;
  badges: number;
  className?: string;
  onClick?: () => void;
};

export const Currency = observer<CurrencyProps>(
  ({
    showBadges = true,
    showCoins = true,
    showXp = true,
    showKeys = true,
    user,
    badges,
    className,
    onClick,
  }) => (
    <div className={clsx(styles.currency, className || '')} onClick={onClick}>
      {showBadges && (
        <Badge>
          <img height={24} width={24} src={cards} alt="" />
          <span>{formatNumberShort(badges)}</span>
        </Badge>
      )}
      {showCoins && (
        <Badge>
          <img height={24} width={24} src={coin} alt="" />
          <span>{formatNumberShort(user.balance)}</span>
        </Badge>
      )}
      {showXp && (
        <Badge>
          <img height={24} width={24} src={star} alt="" />
          <span>{formatNumberShortExt(user.xp ?? 0)}</span>
        </Badge>
      )}
      {showKeys && user.keys !== null && (
        <Badge>
          <img height={24} width={24} src={key} alt="" />
          <span>{formatNumberShort(user.keys)}</span>
        </Badge>
      )}
    </div>
  ),
);
